import { render } from "./DonationPage.vue?vue&type=template&id=132f43a4&scoped=true"
import script from "./DonationPage.vue?vue&type=script&lang=js"
export * from "./DonationPage.vue?vue&type=script&lang=js"

import "./DonationPage.vue?vue&type=style&index=0&id=132f43a4&scoped=true&lang=css"

import exportComponent from "/var/www/donorsweb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132f43a4"]])

export default __exports__